<script>
export default {
  props: {
    aspectRatioValue: [String, Number],
    maxWidth: [String, Number]
  },
  computed: {
    cssVars () {
      return {
        /* variables you want to pass to css */
        // '--vlt-aspect-ratio': this.aspectRatioValue ? this.aspectRatioValue : 56,
        // '--vlt-max-width': this.maxWidth ? this.maxWidth : '560px'
      }
    }
  }
}
</script>

<template>
  <div class="vlt-wrapper">
    <slot/>
  </div>
</template>

<style>
 .vlt-wrapper {
  /* max-width: var(--vlt-max-width); */
  width: 100%;
  height: auto;
  /* height: 200px; */
  aspect-ratio: 16 / 9;
  /* margin-right: 3px; */
  display: inline-block;
  /* background-color: #000000; */
  /* background-color: blue; */
  position: relative;
}
/* .vlt-wrapper * {
  padding: 0;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;
} */
/* .vlt-wrapper::before {
  display: block;
  padding-top: 0%;
  content: "";
} */
.vlt-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
/* @media screen and (max-width: 1420px) {
    .vlt-wrapper{
        width: 550px;
        transition: 0.5s ease;
    }
}
@media screen and (max-width: 720px) {
    .vlt-wrapper{
        width: 450px;
        transition: 0.5s ease;
    }
}
@media screen and (max-width: 550px) {
    .vlt-wrapper{
        width: 400px ;
        transition: 0.5s ease;
        height: 15rem;
    }
}
@media screen and (max-width: 480px) {
    .vlt-wrapper{
        width: 350px;
        height: 12rem;
        transition: 0.5s ease;
    }
}
@media screen and (max-width: 420px) {
    .vlt-wrapper{
        width: 300px;
        height: 10rem;
        transition: 0.5s ease;
    }
}
@media screen and (max-width: 375px) {
    .vlt-wrapper{
        width: 260px;
        height: 10rem;
        transition: 0.5s ease;
    }
} */
</style>
